.root {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  border: 0;
  cursor: pointer;
  font: inherit;
  white-space: nowrap;
}

.sm {
  height: 30px;
  padding: 0 13px;
  font-size: 12px;
}

.md {
  height: 32px;
  padding: 0 13px;
  font-size: 12.5px;
}

.primary {
  background: var(--ink);
  color: var(--bg);
  font-weight: 600;
}
.primary:hover {
  background: var(--accent);
  color: var(--on-accent);
}

.secondary {
  background: var(--panel);
  color: var(--ink);
  border: 1px solid var(--line);
  font-weight: 550;
}
.secondary:hover {
  border-color: var(--ink-4);
}

.ghost {
  background: transparent;
  color: var(--ink-2);
  font-weight: 550;
}
.ghost:hover {
  background: var(--sunk);
  color: var(--ink);
}

.accent {
  background: var(--accent);
  color: var(--on-accent);
  font-weight: 600;
}
.accent:hover {
  filter: brightness(1.05);
}

/* `aria-disabled` — тот же вид, а фокус кнопка не теряет: выключенная роняет его в body. */
.root:disabled,
.root[aria-disabled='true'] {
  background: var(--sunk);
  color: var(--ink-4);
  cursor: not-allowed;
  border-color: transparent;
}
.root:disabled:hover,
.root[aria-disabled='true']:hover {
  filter: none;
  background: var(--sunk);
  color: var(--ink-4);
}
